var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.7 896.2c-71 0-135.3-10.9-181-30.8-34.1-13.8-91.1-45.7-91.1-104.6V307c0-80.4 28.5-156.3 80.2-213.9C373.4 35.5 441.6 3.9 513.7 3.9c150 0 272.1 136 272.1 303.2v453.8c0 53.6-45.9 85-84.4 102-49 21.4-115.6 33.3-187.7 33.3z m0-855.8c-131 0-237.6 120.5-237.6 268.7v453.8c0 66.2 119.5 100.9 237.6 100.9s237.6-34.6 237.6-100.9V307c0-147-106.6-266.6-237.6-266.6z",
    fill: "#f5821f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.1 1016.4c-10.5 0-17.2-6.8-17.2-17.2V677.9c0-178 13.8-300.7 41.2-364.9 21.4-50.2 44.5-50.2 56.9-50.2 10.5 0 17.2 6.8 17.2 17.2 0 10.5-6.8 17.2-17.2 17.2-31.6 0-63.6 130.7-63.6 380.6V997c-0.1 10.9-9.3 19.4-17.3 19.4zM849.2 1016.4c-10.4-0.1-17-6.8-17-17.2V677.9c0-247.2-32.8-380.6-63.6-380.6-10.5 0-17.2-6.8-17.2-17.2 0-10.5 6.8-17.2 17.2-17.2 44.7 0 98.1 72 98.1 415.1v319c0 10.9-9.3 19.3-17.2 19.3-0.2 0-0.3 0.1-0.3 0.1zM685.5 320.1c-10.4-0.1-17.1-6.8-17.1-17.2 0-83.8-63.4-160.4-122.6-179.4-8.6-3.4-13.7-12.1-12.2-20.6 2.9-7.1 8.9-11.2 15.9-11.2 2.1 0 4.3 0.4 6.5 1.1C626.7 115 702.9 202.4 702.9 305c0 8.8-7.3 15.2-17.2 15.2-0.1-0.1-0.1-0.1-0.2-0.1zM685.7 467.3c-10.5 0-17.2-6.8-17.2-17.2v-62.2c0-10.5 6.8-17.2 17.2-17.2 10.5 0 17.2 6.8 17.2 17.2V450c0 10.5-6.8 17.3-17.2 17.3z",
    fill: "#f5821f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNail);
export default __webpack_public_path__ + "static/media/nail.6b432e50b05790c0db381b6bdf8b575d.svg";
export { ForwardRef as ReactComponent };